import { render, staticRenderFns } from "./MakeUserAdmin.vue?vue&type=template&id=5dc05994&scoped=true"
import script from "./MakeUserAdmin.vue?vue&type=script&lang=js"
export * from "./MakeUserAdmin.vue?vue&type=script&lang=js"
import style0 from "./MakeUserAdmin.vue?vue&type=style&index=0&id=5dc05994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc05994",
  null
  
)

export default component.exports